"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var clsx_1 = __importDefault(require("clsx"));
var utils_1 = require("utils");
var LIST_STYLES = "my-2 border border-danger p-2 rounded flex flex-col";
var ITEM_STYLES = "flex font-body text-error text-sm";
var NAME_STYLES = "font-semibold";
var ErrorList = function (_a) {
    var className = _a.className, _b = _a.errors, errors = _b === void 0 ? {} : _b;
    var keys = Object.keys(errors !== null && errors !== void 0 ? errors : {});
    return keys.length ? ((0, jsx_runtime_1.jsx)("ul", __assign({ className: (0, clsx_1.default)(LIST_STYLES, className) }, { children: keys.map(function (k) {
            var _a;
            return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: ITEM_STYLES }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faExclamationTriangle, size: "sm", className: "my-auto text-danger mr-2" }, void 0), (0, jsx_runtime_1.jsxs)("strong", __assign({ className: NAME_STYLES }, { children: [(0, utils_1.humanize)(k), "\u00A0"] }), void 0), " ", (_a = errors[k]) === null || _a === void 0 ? void 0 : _a.message] }), k));
        }) }), void 0)) : null;
};
exports.ErrorList = ErrorList;
